module.exports = __webpack_public_path__ + "img/card_digitizedfile.75c9f49e.svg";